var render = function render(){var _vm=this,_c=_vm._self._c;return _c('GridCard',[_c('CohortsCardContent',{attrs:{"catalogueTitle":_vm.catalogue.title,"lines":_vm.cohortsLines}}),_c('FieldCheckbox',{on:{"change":e => _vm.$emit('change',e)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }